import {Box, Typography, IconButton} from '@mui/material';
import {info, LeftArrow} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {Tooltip} from '@jobseeker/lotus/elements';

interface BackButtonHeaderProps {
  title: string;
  onBackClick: () => void;
  titleExtension?: boolean;
}
export const BackButtonHeader = ({
  title,
  onBackClick,
  titleExtension,
}: BackButtonHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        // position: 'absolute',
        background: '#fff',
        borderRadius: '0 0 16px 16px',
        boxShadow: '8px 6.48px 6px 2px #29292905',
        width: '100%',
        height: '56px',
        px: 1,
      }}
    >
      <IconButton
        sx={{
          mr: 1,
          ':hover': {
            background: 'none',
          },
        }}
        onClick={() => {
          onBackClick();
        }}
      >
        <Image src={LeftArrow} alt="back button" width={16} height={16} />
      </IconButton>
      <Typography variant="subtitle1" sx={{textTransform: 'capitalize'}}>
        {title}
      </Typography>
      {titleExtension && (
        <Tooltip
          placement="bottom-end"
          sx={{
            '& .MuiTooltip-tooltip': {
              maxWidth: '265px',
              padding: '12px',
            },
          }}
          title={
            <>
              <Typography
                display={'flex'}
                component={'p'}
                mb={{xxs: 0.5, md: 0}}
                variant="subtitle3"
              >
                Candidates who verify their contact details are more likely to
                get contacted by the recruiters.
              </Typography>
            </>
          }
          arrow
        >
          <Image
            src={info}
            alt={'info'}
            width={14}
            height={14}
            style={{marginLeft: 4}}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default BackButtonHeader;
